module.exports = __webpack_public_path__ + "static/img/and.6a14dcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/and.svg
// module id = Rbyi
// module chunks = 0